<div id="app-menu-group" pFocusTrap (keyup.escape)="close()">
    <div id="app-menu-group-header">
        <div id="groups-header-label">
            <i class="fa-light fa-users" id="switch-group-icon"></i>
            <label for="switch-group-icon" id="switch-group-label">{{ 'groupsMenu.title' | translate }}</label>
        </div>
        <a [routerLink]="appRoutes.routes().GROUPS_LISTING" tabindex="0" id="group-settings-link">
            <i class="fa-light fa-bell-exclamation"></i>
            <p id="account-settings-label">
                {{ 'groupsMenu.settings' | translate }}
            </p>
        </a>
    </div>

    <div id="app-menu-group-body">
        <nav id="user-group-list" [class.nav-disabled]="isGroupsLoading">
            @for (group of userGroups; track group) {
                <button
                    [id]="'user-group-btn-' + group.id"
                    (click)="selectGroup(group)"
                    [class.selected]="group.id === selectedGroupId"
                    [ariaLabel]="('groupsMenu.switchTo' | translate) + group.name"
                    class="user-group-item-container">
                    <div class="user-group-item">
                        <i class="fa-light fa-circle-check selected-icon" [id]="'user-group-icon-' + group.id"></i>
                        <label [for]="'user-group-icon-' + group.id" [id]="'user-group-label-' + group.id">
                            <span class="group-label">{{ 'profileMenu.group' | translate }}:</span>
                            <app-ellipsis-tooltip
                                [paragraphId]="'group-name-paragraph-' + group.id"
                                [disableTooltip]="true"
                                >{{ group.name }}</app-ellipsis-tooltip
                            >
                        </label>
                    </div>
                    <a
                        tabindex="0"
                        class="redirect-icon"
                        [href]="'/' + group.id"
                        target="_blank"
                        [pTooltip]="'groupsMenu.openInANewTabTooltip' | translate"
                        [ariaLabel]="'groupsMenu.openInANewTabTooltip' | translate"
                        tooltipPosition="left"
                        tooltipFocusHandler
                        (click)="stopPropagation($event)">
                        <i class="fa-regular fa-arrow-up-right-from-square"></i>
                    </a>
                </button>
            }
        </nav>
    </div>
</div>
